import type { EnvPolicyDefinition } from "../capability-model";

/**
 * Environment values every service reads the same way, shared by
 * `deployment-context.ts` and the mobile app's features in
 * `mobile/deployment-context.ts`.
 */

export function environmentEnv(
  name: string,
  field: "id" | "gcpProject" | "mediaPathPrefix",
  mobileEasArtifact?: EnvPolicyDefinition["mobileEasArtifact"],
): EnvPolicyDefinition {
  return {
    name,
    availability: "boot",
    mobileEasArtifact,
    source: { kind: "environment", field },
  };
}

function prodServiceEnv(
  name: string,
  mobileEasArtifact?: EnvPolicyDefinition["mobileEasArtifact"],
): EnvPolicyDefinition {
  return {
    name,
    availability: "boot",
    mobileEasArtifact,
    source: { kind: "doppler", project: "service", config: "prd" },
  };
}

export function staticEnvironmentValue(
  name: string,
  field: "id" | "gcpProject",
  mobileEasArtifact?: EnvPolicyDefinition["mobileEasArtifact"],
  productionMobileEasArtifact = mobileEasArtifact,
) {
  return {
    scope: "runtime",
    environments: {
      local: {
        mode: "managed",
        env: [environmentEnv(name, field, mobileEasArtifact)],
      },
      preview: {
        mode: "managed",
        env: [environmentEnv(name, field, mobileEasArtifact)],
      },
      production: {
        mode: "managed",
        env: [prodServiceEnv(name, productionMobileEasArtifact)],
      },
    },
  } as const;
}
